module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }